const DIGITAL = [
    'savingGoals',
    'billReminders',
    'merchantBudgets',
];
export const checkIsBenefitIdAvailableOnFree = (benefitId, guessedHomeCountry, _) => {
    if (benefitId && guessedHomeCountry === 'GB') {
        return DIGITAL.includes(benefitId);
    }
    return false;
};
